import {Component, Inject, Input, OnInit} from 'ng-metadata/core';
import {PhysicalBestOfferService} from './physicalBestOffer.service';
import {JwtUtilService} from "../../../../security/jwtUtil.service";
import { NgrsService } from '../ngrs.service';

const get= require('lodash/get');

@Component({
    "inputs":['offerfound','display','getitformopen','bestoffer'],
    "selector": "prm-service-physical-best-offer",
    templateUrl: 'components/search/fullView/ngrs/physicalBestOffer/physicalBestOffer.html'
})

export class PrmServicePhysicalBestOffer implements OnInit{
    
    @Input() item:Object;
    
    
    
    constructor(private physicalBestOfferService: PhysicalBestOfferService,
                @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService){
                    let mmsIdArr;                                 
                     mmsIdArr = get(this.item,'pnx.control.sourcerecordid');                                       
         	      if(!mmsIdArr){
              		  this.offerfound.offerFound=false;
           		      this.display.display='display:block';
         	      }else{
              		  let mmsId = mmsIdArr[0];
             	      this.physicalBestOfferService.getbestOffer(mmsId).then((response)=>this.setbestOffer(response));
                }
            
         
    }

    ngOnInit(){

    }

    private setbestOffer(response){
        if(response.supplyTime && response.loanPeriod){
            this.physicalBestOfferService.setBestOffer(response);
            this.display.display='display:block';
            this.offerfound.offerFound=true;
            this.bestoffer.supplyTime=response.supplyTime;
            this.bestoffer.loanPeriod=response.loanPeriod;
            this.bestoffer.cost=response.cost;
            this.bestoffer.allowRenewal=response.allowRenewal;
            this.bestoffer.supportRush=response.supportRush;
            this.bestoffer.memberId=response.memberId;
            this.bestoffer.policyId=response.policyId;
            this.bestoffer.lenderMemberName=response.lenderMemberName;
            this.bestoffer.lenderMemberId=response.lenderMemberId;
            this.bestoffer.availableLenderMmsId=response.availableLenderMmsId;
            this.bestoffer.lenderInstitutionId=response.lenderInstitutionId;
        }
        else{
            this.offerfound.offerFound=false;
            this.display.display='display:block';             
            this.bestoffer.loanPeriod=0; 
            this.bestoffer.supplyTime=0;
        }
    }

    public getItRequest(){
        this.getitformopen.getItFormOpen=true;
    }

    public isShowBestOffer(){
        return !this.getitformopen.getItFormOpen;
    }

    public getSupplyTime(){
     return this.bestoffer.supplyTime;
    }

    public getLoanPeriod(){
     return this.bestoffer.loanPeriod;
    }    

}








// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/ngrs/physicalBestOffer/physicalBestOffer.directive.ts